module.exports = __webpack_public_path__ + "static/media/bike_gravel.370a2a34.webp";